import isPropValid from '@emotion/is-prop-valid';

/**
 * styled-components v6 removed the automatic prop filtering that v5 applied to
 * host (DOM) elements, so custom/styling-only props now leak to the DOM and
 * trigger React "unknown attribute" warnings unless they are transient ($-prefixed).
 *
 * This restores the v5 behaviour: only forward valid HTML/SVG attributes to DOM
 * elements, while always forwarding every prop to custom React components.
 */
export const shouldForwardProp = (prop: string, target: unknown): boolean => {
  if (typeof target === 'string') {
    // `target` is a DOM tag name — only forward standard attributes.
    return isPropValid(prop);
  }
  // `target` is a custom React component — forward everything.
  return true;
};

/**
 * Shared StyleSheetManager configuration that restores the two styled-components
 * v5 defaults that v6 dropped:
 *  - `shouldForwardProp` — re-enables automatic prop filtering for DOM elements.
 *  - `enableVendorPrefixes` — re-enables automatic CSS vendor prefixing, which v6
 *    turns off by default (the codebase relies on auto-prefixing).
 *
 * Spread onto every `<StyleSheetManager>` — server (ServerStyleSheet) and client —
 * so SSR and CSR generate identical CSS.
 */
export const styleSheetManagerProps = {
  shouldForwardProp,
  enableVendorPrefixes: true,
};
